export enum ExecutionStatus {
  SUCCEED = 'SUCCEED',
  FAILED = 'FAILED',
}
